import { Box, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Chip from '@mui/material/Chip';
import { Link } from "react-router-dom";
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';

export default function LeitnerInfo(props) {

  return (
    <Grid container sx={{ height: "80vh" }}>
      {/* <Box sx={{ width: "100%", px: 1 }}> */}
      <Paper sx={{ width: "100%", height: "100%", m: 1, p: 1 }}>
        <Divider>
          <Chip label="لایتنر" />
        </Divider>
        <Typography >
          برای ورود به لایتنر می توانید بر روی  دکمه زیر کلیک کنید
        </Typography>
        <Box sx={{ mx: 1, textAlign: "center" }}>
          <Button variant="contained" color="info" endIcon={<ViewCarouselIcon />} >
            <Link to="/appleitner" style={{ textDecoration: "none" }}
            >ورود به لایتنر</Link>
          </Button>
        </Box>
        <Divider sx={{ my: 1 }} />
        <Typography sx={{ textAlign: "justify", mx: 2 }}>
          سیستم لایتنر یک ابزار یادگیری مفید است که باعث ثبت اطلاعات در حافظه بلندمدت افراد می‌شود. اجرای این روش به‌واسطه یک جعبه چندبخشی ساده و چند فلش‌کارت انجام می‌شود. این تکنیک شامل مرور و بررسی مجموعه‌ای از فلش‌کارت‌ها در فواصل زمانی منظم است.
        </Typography>
      </Paper>
      {/* </Box> */}
    </Grid>
  );
}
